<div class="work-condition-master-container">

  <!-- Header -->
  <div class="master-header">
    <h3>Condiciones Laborales</h3>
    <p>Gestión completa de todas las condiciones laborales del sistema</p>
  </div>

  <!-- Statistics -->
  <div class="stats-container">
    <div class="stat-card clickeable" (click)="toggleShowAllConditions()">
      <div class="stat-icon">
        <i class="fas fa-database"></i>
      </div>
      <div class="stat-content">
        <div class="stat-value">{{ getStats().total }}</div>
        <div class="stat-label">
          Total de Condiciones
          <i class="fas fa-chevron-down" *ngIf="!showAllConditions"></i>
          <i class="fas fa-chevron-up" *ngIf="showAllConditions"></i>
        </div>
      </div>
    </div>

    <div class="stat-card">
      <div class="stat-icon available">
        <i class="fas fa-check-circle"></i>
      </div>
      <div class="stat-content">
        <div class="stat-value">{{ getStats().available }}</div>
        <div class="stat-label">Disponibles</div>
      </div>
    </div>

    <div class="stat-card">
      <div class="stat-icon used">
        <i class="fas fa-users"></i>
      </div>
      <div class="stat-content">
        <div class="stat-value">{{ getStats().used }}</div>
        <div class="stat-label">En Uso</div>
      </div>
    </div>

    <div class="stat-card">
      <div class="stat-icon refused">
        <i class="fas fa-ban"></i>
      </div>
      <div class="stat-content">
        <div class="stat-value">{{ getStats().refused }}</div>
        <div class="stat-label">Rechazadas</div>
      </div>
    </div>
  </div>

  <!-- Add New Condition -->
  <div *ngIf="showNewConditionSection" class="add-condition-section">
    <div class="add-condition-form">
      <div class="form-group">
        <label for="newCondition" class="form-label">
          <i class="fas fa-plus"></i>
          Nueva Condición Laboral
        </label>
        <div class="input-group">
          <input
            type="text"
            id="newCondition"
            class="form-control"
            [(ngModel)]="newCondition"
            placeholder="Ej: Desarrollador Frontend"
            (keyup.enter)="addNewCondition()">
          <button
            class="btn btn-primary"
            [disabled]="!newCondition.trim() || addingCondition"
            (click)="addNewCondition()">
            <i class="fas" [class]="addingCondition ? 'fa-spinner fa-spin' : 'fa-plus'"></i>
            {{ addingCondition ? 'Agregando...' : 'Agregar' }}
          </button>
        </div>
      </div>
    </div>
  </div>

  <!-- Conditions Lists -->
  <div class="conditions-lists">
    <!-- Available Conditions -->
    <div class="conditions-section">
      <h4 class="section-title">
        <i class="fas fa-check-circle"></i>
        Condiciones Disponibles
        <span class="badge">{{ availableWorkConditions.length }}</span>
      </h4>
      <div class="conditions-grid">
        <div
          *ngFor="let condition of availableWorkConditions"
          class="condition-item available"
          [class]="getConditionStatusClass(condition)">

          <div class="condition-content">
            <span class="condition-text">{{ condition }}</span>
            <div class="condition-actions">
              <button
                class="btn btn-sm btn-outline-danger"
                title="Rechazar condición"
                (click)="moveToRefused(condition)"
                [disabled]="!canMoveToRefused(condition)">
                <i class="fas fa-ban"></i>
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Refused Conditions -->
    <div class="conditions-section">
      <h4 class="section-title">
        <i class="fas fa-ban"></i>
        Condiciones Rechazadas
        <span class="badge">{{ refusedWorkConditions.length }}</span>
      </h4>
      <div class="conditions-grid">
        <div
          *ngFor="let condition of refusedWorkConditions"
          class="condition-item refused"
          [class]="getConditionStatusClass(condition)">

          <div class="condition-content">
            <span class="condition-text">{{ condition }}</span>
            <div class="condition-actions">
              <button
                class="btn btn-sm btn-outline-success"
                title="Habilitar condición"
                (click)="moveFromRefused(condition)"
                [disabled]="!canMoveFromRefused(condition)">
                <i class="fas fa-check"></i>
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- Panel de Todas las Condiciones -->
  <div *ngIf="showAllConditions" class="all-conditions-panel">
    <div class="panel-header">
      <h4><i class="fas fa-list"></i> Todas las Condiciones Laborales</h4>
      <button class="btn btn-sm btn-outline-secondary" (click)="toggleShowAllConditions()">
        <i class="fas fa-times"></i>
        Cerrar
      </button>
    </div>

    <div class="panel-body">
      <div class="all-conditions-grid">
        <div
          *ngFor="let condition of allWorkConditions"
          class="all-condition-item"
          [class]="getConditionStatusClass(condition)">
          
          <div class="condition-info">
            <span class="condition-name">{{ condition }}</span>
            <div class="condition-details">
              <span class="condition-badge" [style.background-color]="getConditionStatusColor(condition)">
                {{ getConditionState(condition) }}
              </span>
              <span *ngIf="isConditionInUse(condition)" class="condition-group">
                <i class="fas fa-users"></i>
                Grupo: {{ getGroupForCondition(condition) }}
              </span>
            </div>
          </div>

          <div class="condition-quick-actions">
            <button
              *ngIf="canMoveToRefused(condition)"
              class="btn btn-xs btn-outline-danger"
              (click)="moveToRefused(condition)"
              title="Mover a rechazadas">
              <i class="fas fa-ban"></i>
            </button>
            <button
              *ngIf="canMoveFromRefused(condition)"
              class="btn btn-xs btn-outline-success"
              (click)="moveFromRefused(condition)"
              title="Quitar de rechazadas">
              <i class="fas fa-check"></i>
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>

</div>
